import React, { useState, useEffect } from "react";

function Billing() {
  const [isGST, setIsGST] = useState(false);
  const [goldRate, setGoldRate] = useState(null);
  const [inventory, setInventory] = useState([]);
  const [selectedCustomer, setSelectedCustomer] = useState("");
  const [paymentMode, setPaymentMode] = useState("Cash");
  const [billItems, setBillItems] = useState([]);
  const [selectedItem, setSelectedItem] = useState("");
  const [makingChargeOverride, setMakingChargeOverride] = useState("");
  const [scanInput, setScanInput] = useState("");
  const [discountRate, setDiscountRate] = useState(0);

  useEffect(() => {
    fetch(`/api/goldrate?userId=${parseInt(localStorage.getItem("userId"))}`)
      .then((r) => r.json())
      .then((d) => {
        if (d.length > 0) setGoldRate(d[0]);
      });
    fetch(`/api/inventory?userId=${parseInt(localStorage.getItem("userId"))}`)
      .then((r) => r.json())
      .then((d) => setInventory(d));
  }, []);

  const addItemToBill = () => {
    const item = inventory.find((i) => i.id === parseInt(selectedItem));
    if (!item || !goldRate) return;
    const goldValue = item.weightGrams * goldRate.rate22K;
    const making =
      makingChargeOverride !== ""
        ? parseFloat(makingChargeOverride)
        : item.makingCharge;
    const lineTotal = goldValue + making;
    setBillItems([
      ...billItems,
      { ...item, goldValue, lineTotal, makingUsed: making },
    ]);
    setSelectedItem("");
    setMakingChargeOverride("");
  };

  const handleBillScan = (e) => {
    if (e.key === "Enter" && scanInput.trim() !== "") {
      const found = inventory.find((item) => item.barcode === scanInput.trim());
      if (found && goldRate) {
        const goldValue = found.weightGrams * goldRate.rate22K;
        const making = found.makingCharge;
        const lineTotal = goldValue + making;
        setBillItems([
          ...billItems,
          { ...found, goldValue, lineTotal, makingUsed: making },
        ]);
        alert(`✅ ${found.name} added to bill!`);
      } else {
        alert("❌ Item not found in inventory");
      }
      setScanInput("");
    }
  };

  const removeItem = (index) => {
    setBillItems(billItems.filter((_, i) => i !== index));
  };

  const subtotal = billItems.reduce((sum, i) => sum + i.lineTotal, 0);
  const discountAmount = subtotal * (parseFloat(discountRate) / 100);
  const afterDiscount = subtotal - discountAmount;
  const cgst = isGST ? afterDiscount * 0.015 : 0;
  const sgst = isGST ? afterDiscount * 0.015 : 0;
  const total = afterDiscount + cgst + sgst;

  const saveBill = () => {
    if (!selectedCustomer || billItems.length === 0) {
      alert("Please select a customer and add items");
      return;
    }
    alert(`Bill saved! Total: ₹${total.toFixed(2)}`);
  };

  const inputStyle = {
    width: "100%",
    padding: "8px",
    background: "#C2B067",
    border: "1px solid #856A00",
    borderRadius: "6px",
    color: "#403301",
    fontSize: "13px",
  };
  const labelStyle = {
    fontSize: "12px",
    color: "#403301",
    display: "block",
    marginBottom: "4px",
  };

  return (
    <div
      style={{
        flex: 1,
        padding: "30px",
        color: "#403301",
        background: "#f8f9fa",
        minHeight: "100vh",
      }}
    >
      {/* Header */}
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: "24px",
        }}
      >
        <div>
          <h2 style={{ margin: 0 }}>Billing</h2>
          <p style={{ margin: 0, color: "#856A00", fontSize: "12px" }}>
            Create GST & Non-GST invoices
          </p>
        </div>
        <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
          <span style={{ color: "#856A00", fontSize: "13px" }}>
            {isGST ? "GST Invoice" : "Non-GST Invoice"}
          </span>
          <div
            onClick={() => setIsGST(!isGST)}
            style={{
              width: "40px",
              height: "22px",
              background: isGST ? "#856A00" : "#aaa",
              borderRadius: "11px",
              cursor: "pointer",
              position: "relative",
              transition: "background 0.2s",
            }}
          >
            <div
              style={{
                width: "16px",
                height: "16px",
                background: "gold",
                borderRadius: "50%",
                position: "absolute",
                top: "3px",
                left: isGST ? "21px" : "3px",
                transition: "left 0.2s",
              }}
            />
          </div>
        </div>
      </div>

      <div
        style={{
          display: "grid",
          gridTemplateColumns: "1.4fr 1fr",
          gap: "16px",
        }}
      >
        {/* Left */}
        <div>
          {/* Customer Details */}
          <div
            style={{
              background: "#928243",
              border: "1px solid #856A00",
              borderRadius: "10px",
              padding: "20px",
              marginBottom: "16px",
            }}
          >
            <h3 style={{ margin: "0 0 16px 0", color: "#403301" }}>
              Customer Details
            </h3>
            <div
              style={{
                display: "grid",
                gridTemplateColumns: "1fr 1fr",
                gap: "12px",
              }}
            >
              <div>
                <label style={labelStyle}>Customer Name</label>
                <input
                  placeholder="Enter name"
                  value={selectedCustomer}
                  onChange={(e) => setSelectedCustomer(e.target.value)}
                  style={inputStyle}
                />
              </div>
              <div>
                <label style={labelStyle}>Payment Mode</label>
                <select
                  value={paymentMode}
                  onChange={(e) => setPaymentMode(e.target.value)}
                  style={inputStyle}
                >
                  <option>Cash</option>
                  <option>UPI</option>
                  <option>Card</option>
                  <option>NEFT</option>
                </select>
              </div>
              {isGST && (
                <div>
                  <label style={labelStyle}>Customer GSTIN</label>
                  <input placeholder="22AAAAA0000A1Z5" style={inputStyle} />
                </div>
              )}
              <div>
                <label style={labelStyle}>Bill Date</label>
                <input
                  type="date"
                  defaultValue={new Date().toISOString().split("T")[0]}
                  style={inputStyle}
                />
              </div>
            </div>
          </div>

          {/* Add Items */}
          <div
            style={{
              background: "#928243",
              border: "1px solid #856A00",
              borderRadius: "10px",
              padding: "20px",
            }}
          >
            <h3 style={{ margin: "0 0 16px 0", color: "#403301" }}>
              Add Items
            </h3>

            {/* Barcode Scanner */}
            <div
              style={{
                display: "flex",
                gap: "10px",
                marginBottom: "16px",
                alignItems: "center",
              }}
            >
              <span style={{ fontSize: "20px" }}>Barcode Details</span>
              <input
                type="text"
                placeholder="Scan barcode to add item directly..."
                value={scanInput}
                onChange={(e) => setScanInput(e.target.value)}
                onKeyDown={handleBillScan}
                style={{
                  ...inputStyle,
                  flex: 1,
                  fontSize: "14px",
                  padding: "10px 12px",
                }}
              />
            </div>

            <div
              style={{
                display: "grid",
                gridTemplateColumns: "1fr 1fr 1fr",
                gap: "10px",
                marginBottom: "12px",
              }}
            >
              <div>
                <label style={labelStyle}>Select Item</label>
                <select
                  value={selectedItem}
                  onChange={(e) => setSelectedItem(e.target.value)}
                  style={inputStyle}
                >
                  <option value="">Select from inventory</option>
                  {inventory.map((item) => (
                    <option key={item.id} value={item.id}>
                      {item.name} — {item.purity} — {item.weightGrams}g
                    </option>
                  ))}
                </select>
              </div>
              <div>
                <label style={labelStyle}>
                  Making Charge (₹){" "}
                  <span style={{ color: "#856A00" }}>(override)</span>
                </label>
                <input
                  type="number"
                  placeholder="Leave blank for default"
                  value={makingChargeOverride}
                  onChange={(e) => setMakingChargeOverride(e.target.value)}
                  style={inputStyle}
                />
              </div>
              <div
                style={{
                  display: "flex",
                  alignItems: "flex-end",
                  paddingBottom: "1px",
                }}
              >
                <button
                  onClick={addItemToBill}
                  style={{
                    width: "75%",
                    background: "#856A00",
                    color: "gold",
                    border: "none",
                    padding: "9px 14px",
                    borderRadius: "10px",
                    cursor: "pointer",
                    fontSize: "13px",
                    marginTop: "10px",
                  }}
                >
                  + Add
                </button>
              </div>
            </div>

            <table style={{ width: "100%", borderCollapse: "collapse" }}>
              <thead>
                <tr style={{ borderBottom: "1px solid #856A00" }}>
                  {["Item", "Weight", "Gold Value", "Making", "Total", ""].map(
                    (h, i) => (
                      <th
                        key={i}
                        style={{
                          padding: "8px",
                          textAlign: "left",
                          fontSize: "11px",
                          color: "#403301",
                          textTransform: "uppercase",
                        }}
                      >
                        {h}
                      </th>
                    ),
                  )}
                </tr>
              </thead>
              <tbody>
                {billItems.length === 0 ? (
                  <tr>
                    <td
                      colSpan="6"
                      style={{
                        padding: "20px",
                        textAlign: "center",
                        color: "#403301",
                      }}
                    >
                      No items added yet
                    </td>
                  </tr>
                ) : (
                  billItems.map((item, i) => (
                    <tr key={i} style={{ borderBottom: "1px solid #856A00" }}>
                      <td
                        style={{
                          padding: "8px",
                          fontSize: "13px",
                          color: "#403301",
                        }}
                      >
                        {item.name}
                      </td>
                      <td
                        style={{
                          padding: "8px",
                          fontSize: "13px",
                          color: "#403301",
                        }}
                      >
                        {item.weightGrams}g
                      </td>
                      <td
                        style={{
                          padding: "8px",
                          fontSize: "13px",
                          color: "#403301",
                        }}
                      >
                        ₹{item.goldValue.toFixed(0)}
                      </td>
                      <td
                        style={{
                          padding: "8px",
                          fontSize: "13px",
                          color: "#403301",
                        }}
                      >
                        ₹{item.makingUsed}
                      </td>
                      <td
                        style={{
                          padding: "8px",
                          fontSize: "13px",
                          color: "#403301",
                          fontWeight: "bold",
                        }}
                      >
                        ₹{item.lineTotal.toFixed(0)}
                      </td>
                      <td style={{ padding: "8px" }}>
                        <button
                          onClick={() => removeItem(i)}
                          style={{
                            background: "#403301",
                            color: "#efbf04",
                            border: "none",
                            padding: "2px 8px",
                            borderRadius: "4px",
                            cursor: "pointer",
                            fontSize: "11px",
                          }}
                        >
                          Remove
                        </button>
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
        </div>

        {/* Right — Summary */}
        <div>
          <div
            style={{
              background: "#928243",
              border: "1px solid #856A00",
              borderRadius: "10px",
              padding: "20px",
            }}
          >
            <h3 style={{ margin: "0 0 16px 0", color: "#403301" }}>
              Bill Summary
            </h3>

            {goldRate && (
              <div
                style={{
                  fontSize: "12px",
                  color: "#403301",
                  marginBottom: "12px",
                  padding: "8px",
                  background: "#C2B067",
                  borderRadius: "6px",
                }}
              >
                Gold rate used: <strong>₹{goldRate.rate22K}/g (22K)</strong>
              </div>
            )}

            <div style={{ marginBottom: "12px" }}>
              <label style={labelStyle}>Discount (%)</label>
              <input
                type="number"
                min="0"
                max="100"
                placeholder="0"
                value={discountRate}
                onChange={(e) => setDiscountRate(e.target.value)}
                style={inputStyle}
              />
            </div>

            <div style={{ borderTop: "1px solid #856A00", paddingTop: "12px" }}>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  padding: "6px 0",
                  fontSize: "13px",
                  color: "#403301",
                }}
              >
                <span>Subtotal</span>
                <span>₹{subtotal.toFixed(2)}</span>
              </div>
              {discountRate > 0 && (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    padding: "6px 0",
                    fontSize: "13px",
                    color: "#856A00",
                  }}
                >
                  <span>Discount ({discountRate}%)</span>
                  <span>- ₹{discountAmount.toFixed(2)}</span>
                </div>
              )}
              {isGST && (
                <>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      padding: "6px 0",
                      fontSize: "13px",
                      color: "#403301",
                    }}
                  >
                    <span>CGST (1.5%)</span>
                    <span>₹{cgst.toFixed(2)}</span>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      padding: "6px 0",
                      fontSize: "13px",
                      color: "#403301",
                    }}
                  >
                    <span>SGST (1.5%)</span>
                    <span>₹{sgst.toFixed(2)}</span>
                  </div>
                </>
              )}
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  padding: "10px 0",
                  fontSize: "16px",
                  fontWeight: "bold",
                  color: "#403301",
                  borderTop: "1px solid #856A00",
                  marginTop: "6px",
                }}
              >
                <span>Total</span>
                <span>₹{total.toFixed(2)}</span>
              </div>
            </div>

            <div
              style={{
                marginTop: "16px",
                display: "flex",
                flexDirection: "column",
                gap: "8px",
              }}
            >
              <button
                onClick={saveBill}
                style={{
                  background: "#856A00",
                  color: "gold",
                  border: "none",
                  padding: "10px",
                  borderRadius: "6px",
                  cursor: "pointer",
                  fontSize: "14px",
                  fontWeight: "bold",
                }}
              >
                Generate Bill
              </button>
              <button
                style={{
                  background: "transparent",
                  color: "#403301",
                  border: "1px solid #856A00",
                  padding: "10px",
                  borderRadius: "6px",
                  cursor: "pointer",
                  fontSize: "13px",
                }}
              >
                Send on WhatsApp
              </button>
            </div>

            <div
              style={{ marginTop: "12px", fontSize: "11px", color: "#403301" }}
            >
              Bill #: GR-2026-{Math.floor(Math.random() * 9000) + 1000}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Billing;
